import React from 'react'
import { node, object } from 'prop-types'

export const SiteConfigContext = React.createContext({
	siteConstants: {
		HUB_LINKS: [],
	},
})

/**
 * This is the Site Configuration Provider context component
 * We're able to set all of the site specific constants here so throughout the app we can access this information
 */
export function SiteConfigProvider({ children, siteConstants = {}, siteComponents = {}, featureToggles = {} }) {
	return <SiteConfigContext.Provider value={{ siteConstants, siteComponents }}>{children}</SiteConfigContext.Provider>
}
SiteConfigProvider.propTypes = {
	children: node,
	siteConstants: object,
}
